var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 12.375H9.9c-4.4 0-7.15 2.75-7.15 7.15v3.561c0 4.414 2.75 7.164 7.15 7.164h13.186c4.4 0 7.15-2.75 7.15-7.15v-3.575c.014-4.4-2.736-7.15-7.136-7.15z",
    fill: "url(#xlkqm7adva)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.834 7.659-4.606-4.606a1.037 1.037 0 0 0-1.458 0l-4.606 4.606a1.037 1.037 0 0 0 0 1.457 1.037 1.037 0 0 0 1.458 0l2.846-2.846v14.699c0 .563.467 1.031 1.031 1.031.564 0 1.032-.468 1.032-1.031V6.27l2.846 2.846c.206.207.467.303.729.303.26 0 .522-.097.728-.303a1.013 1.013 0 0 0 0-1.457z",
    fill: "url(#uoa7ngqv0b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xlkqm7adva",
    x1: 2.75,
    y1: 12.375,
    x2: 2.75,
    y2: 30.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uoa7ngqv0b",
    x1: 10.865,
    y1: 2.753,
    x2: 10.865,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.4b232984ab8f16efb200f30b820d66a9.svg";
export { ForwardRef as ReactComponent };